import MusicNoteIcon from '@mui/icons-material/MusicNote';
import HomeIcon from '@mui/icons-material/Home';
import CodeIcon from '@mui/icons-material/Code';
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';
import SportsEsportsIcon from '@mui/icons-material/SportsEsports';
import LiveTvIcon from '@mui/icons-material/LiveTv';
import SchoolIcon from '@mui/icons-material/School';
import FaceRetouchingNaturalIcon from '@mui/icons-material/FaceRetouchingNatural';
import CheckroomIcon from '@mui/icons-material/Checkroom';
import GraphicEqIcon from '@mui/icons-material/GraphicEq';
import TheaterComedyIcon from '@mui/icons-material/TheaterComedy';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import DeveloperModeIcon from '@mui/icons-material/DeveloperMode';
import CurrencyBitcoinIcon from '@mui/icons-material/CurrencyBitcoin';

export const logo = 'https://i.ibb.co/s9Qys2j/logo.png';

export const categories = [
  { name: 'lama dev', icon: <CodeIcon />, },
  { name: 'Love Babbar', icon: <CodeIcon />, },
  { name: 'Apna college', icon: <CodeIcon />, },
  { name: 'javascript mastery', icon: <CodeIcon />, },
  { name: 'clever programmer', icon: <CodeIcon />, },
  { name: 'reactjs', icon: <CodeIcon /> },
  { name: 'Nodejs', icon: <CodeIcon />, },
  { name: 'javascript', icon: <CodeIcon />, },
  { name: 'Joma Tech', icon: <CodeIcon />, },
  { name: 'freeCodeCamp', icon: <CodeIcon />, },
  { name: 'Codewithharry', icon: <CodeIcon />, },
  { name: 'Blockchain Backer', icon: <CurrencyBitcoinIcon />, },
  { name: 'Solana', icon: <CurrencyBitcoinIcon />, },
  { name: 'Blockchain Andy', icon: <CurrencyBitcoinIcon />, },
  { name: 'BLOCKCHAIN MONKEYZ', icon: <CurrencyBitcoinIcon />, },
  { name: 'Alchemy', icon: <CurrencyBitcoinIcon />, },
  { name: 'Crypto', icon: <DeveloperModeIcon />, },
];

export const demoThumbnailUrl = 'https://i.ibb.co/G2L2Gwp/API-Course.png';
export const demoChannelUrl = '/channel/UCmXmlB4-HJytD7wek0Uo97A';
export const demoVideoUrl = '/video/GDa8kZLNhJ4';
export const demoChannelTitle = 'JavaScript Mastery';
export const demoVideoTitle = 'Build and Deploy 5 JavaScript & React API Projects in 10 Hours - Full Course | RapidAPI';
export const demoProfilePicture = 'http://dergipark.org.tr/assets/app/images/buddy_sample.png'